import { reactive } from "vue";

/**
 * État global de la boîte de dialogue d'export (une seule instance, montée dans App.vue).
 */
export const exportDialogState = reactive({
  visible: false,
  format: "excel",
  title: "",
  orientation: "landscape",
  columns: [],
  resolve: null,
});

const STORAGE_PREFIX = "ibacy.export.";

/**
 * Préférences d'export mémorisées par liste (colonnes et ordre uniquement — aucune donnée personnelle).
 */
const loadPreferences = (key) => {
  try {
    return JSON.parse(window.localStorage.getItem(STORAGE_PREFIX + key) || "null");
  } catch (e) {
    return null;
  }
};

export const savePreferences = (key, columns, orientation) => {
  try {
    window.localStorage.setItem(STORAGE_PREFIX + key, JSON.stringify({ columns: columns.filter((c) => c.selected).map((c) => c.key), order: columns.map((c) => c.key), orientation }));
  } catch (e) {
    // Préférences facultatives.
  }
};

/**
 * Ouvre la boîte de dialogue : l'utilisateur choisit les colonnes, leur ordre et, en PDF, l'orientation.
 * Renvoie { columns, orientation, title } ou null si l'export est annulé.
 */
export function openExportDialog({ format, columns, title, orientation = "landscape", preferenceKey }) {
  const prefs = preferenceKey ? loadPreferences(preferenceKey) : null;
  const byKey = new Map(columns.map((column) => [column.key, column]));
  const order = prefs?.order?.filter((key) => byKey.has(key)) || [];
  const ordered = [...order.map((key) => byKey.get(key)), ...columns.filter((column) => !order.includes(column.key))];

  exportDialogState.format = format;
  exportDialogState.title = title;
  exportDialogState.orientation = prefs?.orientation || orientation;
  exportDialogState.columns = ordered.map((column) => ({ ...column, selected: prefs?.columns ? prefs.columns.includes(column.key) : column.exportDefault !== false }));
  exportDialogState.preferenceKey = preferenceKey;
  exportDialogState.visible = true;

  return new Promise((resolve) => {
    exportDialogState.resolve = resolve;
  });
}
